import {Direction} from '@angular/cdk/bidi';
import {LanguageType} from '@shared-types';

export namespace Language {
	export type LangCode = 'he' | 'en' | 'es';
	export type LocaleCountryCode = 'he-IL' | 'en-US' | 'es-ES';

	export type ILanguage = {
		label: string;
		flag: string;
		value: LanguageType;
		dir: Direction;
		iconPath: string;
		lang: {he: boolean; en: boolean};
		oppositeLang: ILanguage;
		position: 'left' | 'right';
		locale_code: LangCode;
		localCountryCode: LocaleCountryCode;
		spacialColor: string;
	};

	export const Hebrew: ILanguage = {
		label: 'עברית',
		flag: 'il',
		value: 'he',
		dir: 'rtl',
		position: 'right',
		locale_code: 'he',
		localCountryCode: 'he-IL',
		iconPath: 'assets/country-flags/circle/il.svg',
		lang: {he: true, en: false},
		oppositeLang: undefined,
		spacialColor: '#0057B7',
	};
	export const English: ILanguage = {
		label: 'English',
		flag: 'gb',
		value: 'en',
		dir: 'ltr',
		position: 'left',
		locale_code: 'en',
		localCountryCode: 'en-US',
		iconPath: 'assets/country-flags/circle/us.svg',
		lang: {he: false, en: true},
		oppositeLang: undefined,
		spacialColor: '#FA8072',
	};

	export const Spanish: ILanguage = {
		label: 'Español',
		flag: 'es',
		value: 'es',
		dir: 'ltr',
		position: 'left',
		locale_code: 'es',
		localCountryCode: 'es-ES',
		iconPath: 'assets/country-flags/circle/es.svg',
		lang: {he: false, en: true},
		oppositeLang: undefined,
		spacialColor: '#FFD700',
	};

	Hebrew.oppositeLang = English;
	English.oppositeLang = Hebrew;
	Spanish.oppositeLang = English;

	export const Languages: Record<LanguageType, ILanguage> = {
		[LanguageType.English]: English,
		[LanguageType.Hebrew]: Hebrew,
		[LanguageType.Spanish]: Spanish,
		[LanguageType.Default]: null,
	};

	export function getAvailableAppLanguages(): LanguageType[] {
		return Object.values(LanguageType).filter(lang => lang !== LanguageType.Default);
	}
}
